import { useRef } from 'react';

export const useFocus = () => {
  const htmlElRef = useRef<HTMLElement>();
  const setFocus = () => htmlElRef.current?.focus();
  return [htmlElRef, setFocus] as const;
};
